module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8grLb"))).then(() => module.bundle.root('ikE14'));